import { ActionModal as UIKitActionModal } from "@/react/components/shared/ModalsV2/ActionModal";
import type { ActionModalProps } from "@/react/components/shared/ModalsV2/ActionModal";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { CompassActionModal } from "./CompassActionModal";

// eslint-disable-next-line no-barrel-files/no-barrel-files -- This is a compatibility layer that re-exports types for SettingsApp
export type { ActionModalProps };

export const ActionModal = (
  props: ActionModalProps & {
    cancelText?: string;
    description?: string;
    loading?: boolean;
    isCancelDisabled?: boolean;
    isFullWidthAction?: boolean;
  },
) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (isCircleV4) {
    const {
      actionText,
      actionVariant,
      isCancelDisabled,
      cancelText,
      children,
      disabled: isDisabled,
      formId,
      isFullWidthAction,
      isOpen,
      onAction,
      onClose,
      description,
      loading: isLoading,
      size,
      title,
    } = props;

    return (
      <CompassActionModal
        description={description}
        actionText={actionText}
        actionVariant={actionVariant}
        isCancelDisabled={isCancelDisabled}
        cancelText={cancelText}
        disabled={isDisabled}
        formId={formId}
        isFullWidthAction={isFullWidthAction}
        isOpen={isOpen}
        onAction={onAction}
        onClose={onClose}
        size={size}
        title={title}
        loading={isLoading}
      >
        {children}
      </CompassActionModal>
    );
  }

  return <UIKitActionModal {...props} />;
};
